// extracted by mini-css-extract-plugin
export default {"header__main_dashboard_title":"ChildGreeting_header__main_dashboard_title__mO5mI"};